import React, { useEffect } from 'react';
import { useLDClient } from 'launchdarkly-react-client-sdk';
import { useSelector } from 'react-redux';
import firebase from 'firebase';
import HeaderBar from '../../components/header/HeaderBar';
import Drawer from '../../components/Drawer';
import Board from '../../components/Board';
import InfoModal from '../../components/InfoModal';
import { LoggedOutBanner } from '../../components/LoggedOutBanner/LoggedOutBanner';
import { getRestaurantId, getUserState } from '../../redux/user/selectors';
import { ENV } from '../../constants/env';
import { Container } from './Home.style';
import { getLocalConfigurationState } from '../../redux/localConfig/selector';

const Home: React.FunctionComponent = () => {
    const ldClient = useLDClient();
    const { user } = useSelector(getUserState);
    const { tagsWhiteList } = useSelector(getLocalConfigurationState);
    const restaurantId = useSelector(getRestaurantId);

    useEffect(() => {
        if (!user || !ldClient || !ENV.LAUNCH_DARKLY_ACTIVE) {
            return;
        }

        const { firstName, lastName, email, userId, brandId, restaurants } = user;
        void ldClient.identify({
            key: userId.toString(),
            firstName,
            lastName,
            email,
            custom: {
                brandId,
                restaurantId: restaurants[0].restaurantId,
            },
        });
    }, [ldClient, user]);

    useEffect(() => {
        if (restaurantId == null) {
            return;
        }

        firebase
            .firestore()
            .collection('restaurants')
            .doc(restaurantId.toString())
            .get()
            .then((doc) => {
                const hasTagsWhiteList = doc.data()?.hasTagsWhiteList as boolean;
                const hasActiveLocalTags = tagsWhiteList.length > 0;

                if (!hasTagsWhiteList && hasActiveLocalTags) {
                    firebase
                        .firestore()
                        .collection('restaurants/')
                        .doc(restaurantId.toString())
                        .set(
                            {
                                hasTagsWhiteList: hasActiveLocalTags,
                            },
                            { merge: true },
                        )
                        .then(() => {
                            console.log('firestore tagsWhiteList updated');
                        })
                        .catch((error) => {
                            console.error('Error updating firestore tagsWhiteList', error);
                        });
                }
            })
            .catch((error) => {
                console.error('Error connecting to firebase', error);
            });
    }, [tagsWhiteList, user, restaurantId]);

    return (
        <Container>
            <HeaderBar />
            <LoggedOutBanner />
            <Board />
            <Drawer />
            <InfoModal />
        </Container>
    );
};

export default Home;
